module.exports = __webpack_public_path__ + "static/img/jzdzlbrule.46be9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jzdzlbrule.png?v=1
// module id = IWtj
// module chunks = 1